import { Button, Dropdown, DropdownDivider, TextInput } from 'flowbite-react';
import { useMemo, useState } from 'react';
import { HiChevronDown } from 'react-icons/hi';

interface IRangeDropdownProps {
  label: string;
  placeholder?: string;
  value: { from: string; to: string } | null;
  onChange?: (value: { from: string; to: string }) => void;
}

export const RangeDropdown = (props: IRangeDropdownProps) => {
  const [fromValue, setFromValue] = useState(props.value?.from || '');
  const [fromValueLabel, setFromValueLabel] = useState(props.value?.from || '');
  const [toValue, setToValue] = useState(props.value?.to || '');
  const [toValueLabel, setToValueLabel] = useState(props.value?.to || '');
  const [isApplyClicked, setIsApplyClicked] = useState(false);

  const TRIGGER_ID = 'dropdown-trigger-button';

  const handleApply = () => {
    const triggerButton = document.getElementById(TRIGGER_ID);
    setFromValueLabel(fromValue);
    setToValueLabel(toValue);
    setIsApplyClicked(true);
    props.onChange && props.onChange({ from: fromValue, to: toValue });
    if (triggerButton) {
      triggerButton.click();
    }
  };

  const selectedText = useMemo(() => {
    if (fromValueLabel && toValueLabel)
      return `От ${fromValueLabel} до ${toValueLabel}`;
    if (fromValueLabel) return `От ${fromValueLabel}`;
    if (toValueLabel) return `До ${toValueLabel}`;
    return '-';
  }, [fromValueLabel, toValueLabel]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
  };
  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-medium text-gray-900">{props.label}</div>
      <Dropdown
        className="max-w-fit"
        color="second"
        label={props.placeholder}
        dismissOnClick={false}
        renderTrigger={() => (
          <Button
            color="second"
            className="flex justify-between px-3 py-2"
            id={TRIGGER_ID}
          >
            <div className="truncate flex">
              <div className="text-gray-900 mr-1">
                {isApplyClicked || props.value
                  ? selectedText
                  : props.placeholder}
              </div>
            </div>
            <div className="flex items-center">
              <HiChevronDown className="w-5 h-5 text-gray-900" />
              {/* <Icon name="chevron-down" color='text-gray-900'/> */}
            </div>
          </Button>
        )}
      >
        <div className="p-3 w-64 space-y-3">
          <div className="text-sm font-medium text-gray-900 dark:text-white">
            {props.placeholder}
          </div>

          <DropdownDivider />

          <TextInput
            id="from-input"
            type="number"
            placeholder="От:"
            value={fromValue}
            onChange={(e) => setFromValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />

          <TextInput
            id="to-input"
            type="number"
            placeholder="До:"
            value={toValue}
            onChange={(e) => setToValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />

          <div className="pt-2">
            <Button
              onClick={() => handleApply()}
              color="primary"
              className="w-full justify-center"
              disabled={!fromValue && !toValue}
            >
              Применить
            </Button>
          </div>
        </div>
      </Dropdown>
    </div>
  );
};
